export const CLOUDFRONT_URL = "https://d16gku0mdgm9y9.cloudfront.net";

export const videoFileFormats = [
	"mp4",  // MPEG-4 Part 14
	"m4v",  // MPEG-4 Video
	"mov",  // Apple QuickTime Movie
	"avi",  // Audio Video Interleave
	"wmv",  // Windows Media Video
	"flv",  // Flash Video
	"mkv",  // Matroska Video
	"webm", // WebM
	"mpg",  // MPEG-1 or MPEG-2
	"mpeg", // MPEG Video
	"3gp",  // 3GPP Multimedia File
	"3g2",  // 3GPP2 Multimedia File
	"ogv",  // Ogg Video
	"asf",  // Advanced Systems Format
	"rm",   // RealMedia
	"rmvb", // RealMedia Variable Bitrate
	"vob",  // DVD Video Object
	"mts",  // MPEG Transport Stream
	"m2ts", // Blu-ray Disc Audio-Video (BDAV)
	"ts",   // Transport Stream
	"f4v",  // Flash MP4 Video
	"f4p",  // Protected MP4 Video
	"f4a",  // MP4 Audio
	"f4b",  // MP4 Audiobook
	"mxf",  // Material Exchange Format
	"divx", // DivX Video
	"dv",   // Digital Video
	"vid",  // General Video File
	"avchd",// Advanced Video Coding High Definition
	"hevc", // High Efficiency Video Coding
	"vp9",  // VP9 Video
	"h264", // H.264 Video
	"h265", // H.265 Video
	"yuv",  // YUV Encoded Video
	"roq",  // Id Software RoQ Video
	"amv",  // Anime Music Video
	"gifv", // GIF Video
	"bik",  // Bink Video
	"drc",  // Dirac Video
	"mve",  // Interplay Video
	"ivf",  // IVF Video
	"nut"   // NUT Video
];

export const imageFileTypes = [
	'jpg', 'jpeg', 'jfif', 'pjpeg', 'pjp',  // JPEG formats
	'png',  // PNG format
	'gif',  // GIF format
	'bmp',  // Bitmap format
	'webp',  // WebP format
	'svg', 'svgz',  // SVG (Scalable Vector Graphics)
	'tiff', 'tif',  // TIFF formats
	'ico',  // ICO format for icons
	'heic', 'heif',  // High Efficiency Image Format (Apple)
	'avif',  // AVIF format (next-gen format based on AV1)
	'raw', 'arw', 'cr2', 'nef', 'orf', 'sr2',  // RAW image formats for cameras (Sony, Canon, Nikon, Olympus)
	'dng',  // Digital Negative format
	'eps',  // Encapsulated PostScript (vector graphics with embedded raster images)
	'psd',  // Photoshop Document
	'psb',  // Large Document Format for Photoshop
	'ai',  // Adobe Illustrator file format (with raster data)
	'indd',  // Adobe InDesign document
	'emf', 'wmf',  // Windows Metafile formats (vector/raster hybrid)
	'ras',  // Sun Raster format
	'pcx',  // PCX image format (legacy format)
	'tga', 'icb', 'vda', 'vst',  // Targa image formats
	'xpm',  // X PixMap format
	'ppm', 'pgm', 'pbm', 'pnm',  // Portable image formats
	'dds',  // DirectDraw Surface format for textures
	'xwd',  // X Window Dump image format
	'hdr', 'exr',  // High Dynamic Range (HDR) formats
	'jpx', 'jpf',  // JPEG 2000 formats
	'sgi', 'rgb', 'rgba', 'bw',  // SGI image formats
	'pic',  // Pictor format
	'pict', 'pct',  // Apple PICT format
	'sketch',  // Sketch design tool format
	'palm',  // Palm Pilot image format
	'qtif',  // QuickTime Image Format
	'icns',  // macOS icon format
	'cur',  // Windows cursor format
	'ani',  // Windows animated cursor format
	'xbm',  // X BitMap format
	'jbig', 'jbg',  // JBIG image formats
	'rle',  // Run-Length Encoding compressed images (used in BMPs)
	'cgm',  // Computer Graphics Metafile
	'djvu', 'djv',  // DjVu format for scanned documents
	'otb',  // Nokia Over The Air Bitmap
	'fpx',  // FlashPix format
	'pgf',  // Progressive Graphics File
	'exif',  // Exchangeable image file format
	'bpg'  // Better Portable Graphics format
  ];